export const FAMILY = {
  value: "FAMILY",
  key: "memberCoverages.types.family",
  excludedGuaranteeCodes: [],
  excludedGuaranteeNames: [],
};

export const COUPLE = {
  value: "COUPLE",
  key: "memberCoverages.types.couple",
  excludedGuaranteeCodes: [],
  excludedGuaranteeNames: [],
};

export const SINGLE = {
  value: "SINGLE",
  key: "memberCoverages.types.single",
  excludedGuaranteeCodes: ["DEPLIFE"],
  excludedGuaranteeNames: ["vie des personnes à charge", "life of dependents"],
};

export const SINGLE_PARENT = {
  value: "SINGLE_PARENT",
  key: "memberCoverages.types.singleParent",
  excludedGuaranteeCodes: [],
  excludedGuaranteeNames: [],
};

export const WAIVED = {
  value: "WAIVED",
  key: "memberCoverages.types.waived",
  excludedGuaranteeCodes: ["HEALTH", "DNTL", "CFSS", "TRAVEL", "SL"],
  excludedGuaranteeNames: [
    // Lines match above order
    // FR                                EN
    "santé",
    "health",
    "dentaire",
    "dental",
    "compte flexible de soins de santé",
    "flexible health care account",
    "voyage",
    "travel",
    "arrêt de perte",
    "stop loss",
  ],
};

export default [FAMILY, COUPLE, SINGLE, SINGLE_PARENT, WAIVED];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/coverage/enums/memberCoverageGuaranteeTypes.js